/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Badge, Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Section from 'solis/claude/primitive/section';

import LinkAccount from 'solis/claude/button/link.account';
import SignOut from 'solis/claude/button/sign.out';

import { colorAt } from 'solis/theme/palette';


export default () =>
{
  const galaxy = use(Galaxy);

  const account = galaxy.getCurrentAccount();

  return (
    <Section label = 'Account'>
      <Flex align = 'center' justify = 'between'>
        <Badge size = '3' variant = 'soft' radius = 'full' color = {colorAt(account.cass.theme)}>{account.cass.name}</Badge>
        <Flex gap = '2'>
          <LinkAccount />
          <SignOut />
        </Flex>
      </Flex>
    </Section>
  );
};
